module.exports = __webpack_public_path__ + "static/apollo-a85f9cfca2d4c3f2947c2583538ea5f5.jpg";